module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/course/labs/awsop/awsop-lab9/awsop-lab9.component.css
// module id = ./src/app/course/labs/awsop/awsop-lab9/awsop-lab9.component.css
// module chunks = main